<div class="h-100 d-flex flex-column">
	<app-title></app-title>
  
	<div class="flex-grow-1" style="overflow: auto;">
		<mat-card class="col-12 bg-acblue bg-img-acblue-2 text-white" style="margin: auto">
			<div class="row align-items-center">
				<div class="col-sm-2 col-3 text-center d-md-block">
          <img src="assets/img/pointer-icon.svg" class="w-50 me-2" />
				</div>
				<div class="col-sm-10 col-9 d-flex align-items-center">
					<p class="lead font-weight-bold"  style="line-height: 1.5;">
						<span>{{ site[properyNameToDisplay] }}</span><br />
						<span>{{ site[properyAddressToDisplay] }}</span><br />
						<span *ngIf="city"> {{ city.postalCode }} {{ city[text] }} </span>
					</p>
				</div>
			</div>
		</mat-card>
	</div>

	<div class="row mt-3">
		<div class="col">
			<app-btn [dataTxt]="'EDIT'" (callback)="onClickRetour()" [icon]="'chevron-left'" [iconLocation]="'left'"></app-btn>
		</div>
		<div class="col text-right">
			<app-btn [dataTxt]="'NEXT'" [classes]="'btnAnimation'" (callback)="onClickOk()" [icon]="'chevron-right'" [iconLocation]="'right'"></app-btn>
		</div>
	</div>
</div>
